// extracted by mini-css-extract-plugin
export default {"zoomContainerWrapper":"ZoomContainer_zoomContainerWrapper__5GeqH","zoomContainerContent":"ZoomContainer_zoomContainerContent__u9T9i"};